import { IconProps } from './type';

export const ICReservationImport: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="22" y="24" width="84" height="82" rx="16" fill="#4f4b5c" />
            <path
                d="M38 24H90C98.8 24 106 31.2 106 40V46H22V40C22 31.2 29.2 24 38 24Z"
                fill="#a797ff"
            />
            <rect x="40" y="14" width="8" height="22" rx="4" fill="#374151" />
            <rect x="80" y="14" width="8" height="22" rx="4" fill="#374151" />
            <path
                d="M64 58V86"
                stroke="#F1EEFF"
                strokeWidth="8"
                strokeLinecap="round"
            />
            <path
                d="M50 74L64 88L78 74"
                stroke="#F1EEFF"
                strokeWidth="8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="44" y="94" width="40" height="8" rx="4" fill="#22C55E" />
        </svg>
    );
};
